<template>
  <section class="email">
    <span> {{ $t("password.info_email") }} </span>

    <v-form
      @submit.prevent="sendEmail"
      v-model="formValidation"
      lazy-validation
      ref="form"
    >
      <v-text-field
        v-model="email"
        :label="$t('inputs.email')"
        class="border__radius-10"
        :placeholder="$t('placeholders.email')"
        :rules="[rules.requerid, rules.email]"
        outlined
        dense
      ></v-text-field>
    </v-form>

    <v-btn
      class="border__radius-10 btn__default btn"
      color="primary"
      @click="sendEmail"
      height="40"
      depressed
      :disabled="isLoading || !checkEmail"
      :loading="isLoading"
      block
    >
      {{ $t("buttons.advance") }}
      <v-icon class="icon" size="18">mdi-arrow-right</v-icon>
    </v-btn>
  </section>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import formRules from "@/mixins/formRules";
import { setEmail } from "@/services/password";

export default {
  name: "PasswordEmailComponent",

  data: () => ({
    email: "",
    isLoading: false,
  }),

  computed: {
    ...mapGetters({
      storeResource: "getPasswordInfos",
    }),

    checkEmail() {
      const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return regex.test(this.email);
    },
  },

  mixins: [formRules],

  components: {},

  methods: {
    ...mapActions(["changePasswordDetails", "changePasswordStep"]),

    async sendEmail() {
      if (this.$refs.form.validate()) {
        this.isLoading = true;

        const data = { email: this.email };
        const { response, status } = await setEmail(data);

        if (status) {
          this.changePasswordDetails(data);
          this.changePasswordStep("Token");
        } else {
          this.$snackbar.setParams(
            "error",
            this.$t("messages.error_not_defined"),
            response.message
          );
        }

        this.isLoading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/_variables.scss";

.email {
  display: flex;
  flex-direction: column;
  text-align: center;
  gap: 15px;

  span {
    font-weight: 400;
    color: $gray;
    padding: 0 40px;
  }

  .btn {
    margin-top: -10px;
  }

  .icon {
    position: absolute;
    right: 0px;
  }
}
</style>
